// extracted by mini-css-extract-plugin
module.exports = {"main_infos":"BaseInfo_main_infos__2T1Hd","item_ele":"BaseInfo_item_ele__3aosN","lable_name":"BaseInfo_lable_name__3gFlj","content_txt":"BaseInfo_content_txt__2E-Fp"};